<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="col-content show-display">
  <div class="header-content mb-xl-5 mb-3">
    <div class="heading">{{puntoRecogidaInfo?.razonSocial}}</div>
  </div>
  <form [formGroup]="formGroup" *ngIf="canAccessCodeLerViewForm()">
    <div class="row form">
      <div class="col-sm flex-grow-2">
        <label for="codigoLer">Código LER y descripción de ENVALORA <span class="oblig">* </span> <em
            *ngIf="formGroup.get('codigoLer')?.value?.peligrosidad === true" class="fas fa-skull-crossbones"
            style="color: #B80F61;" matTooltip="Envase de tipo peligroso"></em></label>
        <div class="custom-mat-field">
          <lib-ge-select-pagination class="lib-ge-select" [endPointFilter]="codigosLerEndpoint"
            [updateList]="updateList" [descripcion]="getLerDescription"
            [formControlNameSelect]="getFormControl('codigoLer')" [objQueryName]="getObjectQuery" [disabled]="flagDisabledForm"
            [placeHolder]="'-- Código LER y descripción de ENVALORA --'" [customClass]="rightHolder('codigoLer')">
          </lib-ge-select-pagination>
          <!-- <div class="ge-select-error">
            <mat-error class="ge-select-mat-error" *ngIf="selPaginatorHasError('codigoLer')">Campo
              obligatorio
            </mat-error>
          </div> -->
        </div>
      </div>
    </div>
    <div class="row-fields pt-3">
      <div class="field field-33">
        <label for="cantidadKgA">Cantidad Estimada (Kg/año)</label>
        <div class="custom-mat-field">
          <mat-form-field appearance="outline" class="custom-mat-form-field-width">
            <input formControlName="cantidadKgA" id="cantidadKgA" placeholder="Cantidad Estimada (Kg/año)" matInput
              type="text" appTwoDigitDecimalNumber>
          </mat-form-field>
        </div>
      </div>

      <div class="field field-33">
        <label for="periocidadTraslado">Periodicidad de Traslados <span class="oblig">* </span></label>
        <div class="custom-mat-field">
          <mat-form-field class="custom-mat-form-field-width" appearance="outline">
            <mat-select formControlName="periocidadTraslado" id="periocidadTraslado"
              placeholder="Periodicidad de Traslados">
              <mat-option *ngFor="let item of filteredOptions" [value]="item">
                {{ item.description }}
              </mat-option>
            </mat-select>
            <span *ngIf="showClearButton('periocidadTraslado')" tabindex="0" class="ng-clear-wrapper"
              (click)="clearSelection($event,'periocidadTraslado')">
              <span aria-hidden="true" class="ng-clear">×</span>
            </span>
          </mat-form-field>
        </div>
      </div>

      <div class="field field-33">
        <label for="acondicionamiento">Acondicionamiento <span class="oblig">*</span></label>
        <div class="custom-mat-field">
          <mat-form-field class="custom-mat-form-field-width" appearance="outline">
            <mat-select formControlName="acondicionamiento" id="acondicionamiento" placeholder="Acondicionamiento">
              <mat-option *ngFor="let item of acondicionamientoArray" [value]="item">
                {{ item.descripcion }}
              </mat-option>
            </mat-select>
            <span *ngIf="showClearButton('acondicionamiento')" tabindex="0" class="ng-clear-wrapper"
              (click)="clearSelection($event,'acondicionamiento')">
              <span aria-hidden="true" class="ng-clear">×</span>
            </span>
          </mat-form-field>
        </div>
      </div>
      <div class="col-sm flex-grow-0" *ngIf="canAccessAgregar()">
        <div class="button-group" style="margin-top:26px;">
          <button style="float:right" type="button" (click)="addPrevision()" class="btn btn-primary">Agregar</button>
        </div>
      </div>
    </div>

  </form>
  <div class="datatable-container table-responsive">
    <lib-ge-table [headArray]="headArray" [gridArray]="grid" (actionButton)="action($event)">
    </lib-ge-table>
  </div>
</div>